import { GET_ALL_HELPER_PRICINGS } from "../actionTypes/actionTypes";
import { HelperPricingDetails, Indice } from "../types/helper-pricing";

interface StateType {
  indices: HelperPricingDetails[];
  indice: Indice;
}

const INITIAL_STATE: StateType = {
  indices: [],
  indice: {
    package_size: "",
    price_per_km: 0,
    price_per_min: 0,    
    base_price: 0,
  },
};

const helperPricingReducer = (state = INITIAL_STATE, action: { type: string; payload: any }) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_HELPER_PRICINGS:
      return Object.assign({}, state, { indices: payload });
    default:
      return state;
  }
};

export default helperPricingReducer;
